jQuery(function ($) {
  $('.section-contract-information table').matchHeight({
    byRow: true,
    property: 'height',
    target: null,
    remove: false
  });
});
